import 'lodash';
import './base/';
import './base/custom-quantity';
import './base/radio-buttons';
import './base/target-events';
import './modules/newsletter-popup';
import { setCookie, getCookie, eraseCookie } from './base/cookies';
import introAnimated from './base/intro-animated';
import { updateVariant } from './base/radio-buttons';
import { loadQuantity } from './base/custom-quantity';
import { accordion } from './base/accordion';

const $win = $(window);
const $doc = $(document);
const $body = $('body');
const windowHref = window.location.href;

if ($('.js-intro-animation').length) {
  if (performance.navigation.type == 1) {
    window.location.href = '/'
  }
}

const getCurrentCookieUrl = getCookie('intro_animation');

if (($('.js-intro-animation').length && getCurrentCookieUrl === windowHref) || ($('.js-intro-animation').length && getCurrentCookieUrl === null)) {
	const introAnimations = getCookie('intro_animation');

	introAnimated();
}

setCookie('intro_animation', windowHref);

getNavText();
updateVariant();

if ($('.remove-pointer').length) {
	$('.remove-pointer').on('click', function(e) {
		e.preventDefault();
	});
}

//Mobile Nav
var isMobile = {
	Android: function() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function() {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function() {
		return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
	},
};

mobileNavigation();

$('.js-trigger-header').on('click', function(e) {
	e.preventDefault();
	$body.toggleClass('has-menu-opened');
});

if ($('js-remove-click').length) {
	$('.js-remove-click').on('click', function(e) {
		e.preventDefault();
	});
}

function mobileNavigation() {
	$('.menu__item--has-dropdown > a').on('click', function(e) {
		if ($win.width() < 1024) {
			if (
				!$(this)
					.parent()
					.hasClass('js-show')
			) {
				e.preventDefault();

				$(this)
					.next()
					.slideDown()
					.parent()
					.addClass('js-show')
					.siblings()
					.removeClass('js-show')
					.find('.menu__dropdown')
					.slideUp()
					.find('.js-show')
					.removeClass('js-show');
			} else {
				if ($(this).hasClass('js-remove-click')) {
					e.preventDefault();
				}
				$(this)
					.parent()
					.removeClass('js-show')
					.find('.menu__dropdown')
					.slideUp()
					.find('.js-show')
					.removeClass('js-show');
			}
		}
	});
}

loadQuantity();
accordion('.accordion .accordion__head', true);

createCartPopup($('.cart-link'), $('.popup-cart .popup__body'));
removeItem($('.popup-cart .popup__body'));

// Create Cart Popup
function createCartPopup($link, $cartPopupContent) {
	var href = $link.attr('href');

	$('.product__form').on('submit', function(event) {
		event.preventDefault();

		$.ajax({
			url: '/cart/add',
			data: $(this).serialize(),
			type: 'POST',
			beforeSend: function() {
				$('.popup-cart').addClass('loads');
				$('.section-cart').addClass('loads');
			},
			complete: function() {
				$('.popup-cart').removeClass('loads');
				$('.section-cart').removeClass('loads');
			},
		})
			.done(function(data) {
				populateCartPopup($cartPopupContent, data);
				loadQuantity();

				$('.popup-cart').addClass('open');
				$('.popup-cart').removeClass('loads');
			})
			.fail(function(data) {
				alert('There are no more available products from this option.');
			});
	});

	$.ajax({
		url: href,
		type: 'GET',
		beforeSend: function() {
			$('.popup-cart').addClass('loads');
			$('.section-cart').addClass('loads');
		},
		complete: function() {
			$('.popup-cart').removeClass('loads');
			$('.section-cart').removeClass('loads');
		},
	}).done(function(data) {
		$cartPopupContent.html(
			$(data)
				.find('.section-cart')
				.html()
		);
		loadQuantity();
	});
}

$('.js-cart').on('click', function(event) {
	event.preventDefault();

	$('.popup-cart').toggleClass('open');
});

// remove Item from cart
function removeItem($cartPopupContent) {
	$doc.on('click', '.popup-cart .table__name .remove', function(event) {
		event.preventDefault();

		var $button = $(this);

		$button.closest('tr').slideUp(200);

		$.ajax({
			url: $button.attr('href'),
			beforeSend: function() {
				$('.popup-cart').addClass('loads');
				$('.section-cart').addClass('loads');
			},
			complete: function() {
				$('.popup-cart').removeClass('loads');
				$('.section-cart').removeClass('loads');
			},
		}).done(function(data) {
			populateCartPopup($cartPopupContent, data);
			loadQuantity();
		});
	});
}

// populate Cart Popup
function populateCartPopup($cartPopupContent, data) {
	var $cartTextLink = $('.cart-link .count');

	var cartTextNew = $(data)
		.find('.item-counter')
		.text();

	$cartTextLink.text(cartTextNew);

	var count = parseInt(cartTextNew);

	$cartPopupContent.html(
		$(data)
			.find('.section-cart')
			.html()
	);
}

function getNavText() {
	$('.js-nav-text a').each(function() {
		let text = $(this).text();
		$(this).attr('data-text', text);
	});
}

/**
 * Show/Hide header on scroll up/down
 */
let lastScroll = null;

$win.on(
	'load scroll',
	_.throttle(() => {
		const top = $win.scrollTop();

		if (top <= 0) {
			$('.header').removeClass('remove-category');
		}

		if ((top > lastScroll && top > 15) || top > $('.footer').offset().top) {
			// remove animation
			// animationBase();
			if ($('.js-intro-animated').length) {
				$('.js-intro-animated').slideUp(1000, () => {
					$('.has-intro-animation').addClass('intro-finished-animating');
				});
			}
		}

		$('.header').toggleClass('down', (top > lastScroll && top > 15) || top > $('.footer').offset().top);

		lastScroll = top;
	}, 100)
);
